"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityMemberDto = instanceOfFacilityMemberDto;
exports.FacilityMemberDtoFromJSON = FacilityMemberDtoFromJSON;
exports.FacilityMemberDtoFromJSONTyped = FacilityMemberDtoFromJSONTyped;
exports.FacilityMemberDtoToJSON = FacilityMemberDtoToJSON;
exports.FacilityMemberDtoToJSONTyped = FacilityMemberDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityMemberDto interface.
 */
function instanceOfFacilityMemberDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function FacilityMemberDtoFromJSON(json) {
    return FacilityMemberDtoFromJSONTyped(json, false);
}
function FacilityMemberDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': (json['dateOfBirth'] == null ? null : new Date(json['dateOfBirth'])),
        'email': json['email'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function FacilityMemberDtoToJSON(json) {
    return FacilityMemberDtoToJSONTyped(json, false);
}
function FacilityMemberDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': (value['dateOfBirth'] == null ? null : value['dateOfBirth'].toISOString().substring(0, 10)),
        'email': value['email'],
        'createdAt': ((value['createdAt']).toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=FacilityMemberDto.js.map